import request from '@/utils/request'

/**
 * 获取用户列表信息
 * @param {Object} params 查询参数
 * @returns {Promise} 返回用户列表数据
 */
export function getUserInfo(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.listUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新用户信息
 * @param {Object} data 用户数据
 * @returns {Promise} 返回更新结果
 */
export function updateUserInfo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.updateUser',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取当前登录用户信息
 * @returns {Promise} 返回当前用户信息
 */
export function getCurrentUserInfo() {
  return new Promise((resolve, reject) => {
    request({
      url: '/nav/getUserInfo',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}